// @flow
import BaseComponent from '../base_component/base_component'

export default class ConsentBanner extends BaseComponent {
    constructor(id: number, component_name: string) {
        super(id, component_name);
        this.acceptCookies();
        this.setCookiesOnScroll();
        this.hideCookieMessage();
    }

    setCookie() {
        document.cookie = 'acceptedSingletrackCookies=1';
        document.cookie = "path=''";
    }

    hideCookieMessage() {
        const self = this;
        if (document.cookie.includes('acceptedSingletrackCookies=1')) {
            self.hideClass('.cookieMessage');
        }
    }

    hideClass(class_name: string) {
        $(class_name).hide();
    }

    acceptCookies() {
        const self = this;
        $('#acceptCookies').click(function() {
            self.setCookie();
            self.hideClass('.cookieMessage')
        });
    }

    setCookiesOnScroll() {
        const self = this;
        $(window).scroll( function () {
            if ($(window).scrollTop() > 50) {
                self.setCookie();
                self.hideClass('.cookieMessage')
            }
        });
    }
}
